import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import CheckBox from 'yoda-core-components/lib/components/CheckBox';
import {
    EXPRESS_CHECKOUT_EXPRESS_CHECKOUT_LABEL,
    EXPRESS_CHECKOUT_EXPRESS_CHECKOUT_DESCRIPTION,
} from 'yoda-checkout-components/lib/common/Constants';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import ExpressCheckoutAction from '../../../../../actions/ExpressCheckoutAction';

export function ExpressCheckout(props) {
    const onToggleExpressCheckout = () => {
        props.actions.toggleExpressCheckout(
            props.addressExpressCheckout,
            props.paymentExpressCheckout
        );
    };
    const {
        expressCheckoutInfo: { enableExpressCheckout },
    } = props;
    return (
        <div
            className={dt([
                'w-full',
                'h-auto',
                'rounded-lg',
                'bg-light-white',
                'mb-6',
                'p-3',
                'mt-6',
            ])}
        >
            <CheckBox
                id="expressChkbox"
                name="expressChkbox"
                automationId="express-checkout-review"
                label={EXPRESS_CHECKOUT_EXPRESS_CHECKOUT_LABEL}
                checked={enableExpressCheckout}
                onClick={onToggleExpressCheckout}
                className={dt(['!mb-0', 'font-bold'])}
            />
            <p className={dt(['pl-9', 'text-medium'])}>
                {EXPRESS_CHECKOUT_EXPRESS_CHECKOUT_DESCRIPTION}
            </p>
        </div>
    );
}

ExpressCheckout.propTypes = {
    actions: PropTypes.objectOf(PropTypes.func).isRequired,
    addressExpressCheckout: PropTypes.bool,
    paymentExpressCheckout: PropTypes.bool,
    expressCheckoutInfo: PropTypes.objectOf(PropTypes.func),
};

ExpressCheckout.defaultProps = {
    addressExpressCheckout: null,
    paymentExpressCheckout: null,
    expressCheckoutInfo: {},
};

/* istanbul ignore next */
const mapStateToProps = ({ expressCheckoutInfo }) => ({
    expressCheckoutInfo,
});

/* istanbul ignore next */
const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators({ ...ExpressCheckoutAction }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(ExpressCheckout);
